/*
 * Mr Swagman swag compare.
 * Product cards (snippets/mrs-card-extras.liquid) carry a Compare tick box with the swag's
 * details in data-mrs-compare. Ticked swags (up to 3) show in a bar at the bottom of the
 * screen and open side by side in a table. The selection is remembered between pages.
 * Blank specs show "Ask Us".
 */
(() => {
  if (window.mrsCompareLoaded) return;
  window.mrsCompareLoaded = true;

  const STORAGE_KEY = 'mrs-compare-v1';
  const MAX_ITEMS = 3;
  const ROWS = [
    ['type', 'Type'],
    ['sleeps', 'Sleeps'],
    ['size', 'Size'],
    ['headroom', 'Headroom'],
    ['packed', 'Packed size'],
    ['weight', 'Weight'],
    ['mattress', 'Mattress'],
    ['canvas', 'Canvas'],
    ['floor', 'Floor'],
    ['frame', 'Frame'],
    ['mesh', 'Insect mesh'],
    ['warranty', 'Warranty'],
  ];

  let items = load();
  let bar;
  let dialog;
  let noticeTimer;

  function load() {
    try {
      const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(saved) ? saved.slice(0, MAX_ITEMS) : [];
    } catch (error) {
      return [];
    }
  }

  function save() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (error) {
      /* Private browsing: the selection just won't persist between pages. */
    }
  }

  function el(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function readCard(input) {
    try {
      return JSON.parse(input.dataset.mrsCompare);
    } catch (error) {
      return null;
    }
  }

  function syncCheckboxes() {
    const selected = new Set(items.map((item) => item.handle));
    document.querySelectorAll('.mrs-compare-toggle__input').forEach((input) => {
      const data = readCard(input);
      if (data) input.checked = selected.has(data.handle);
    });
  }

  function notice(message) {
    let box = document.querySelector('.mrs-compare-notice');
    if (!box) {
      box = el('div', 'mrs-compare-notice');
      box.setAttribute('role', 'status');
      document.body.append(box);
    }
    box.textContent = message;
    box.hidden = false;
    clearTimeout(noticeTimer);
    noticeTimer = setTimeout(() => {
      box.hidden = true;
    }, 2500);
  }

  function renderBar() {
    if (!bar) {
      bar = el('div', 'mrs-compare-bar');
      bar.setAttribute('role', 'region');
      bar.setAttribute('aria-label', 'Compare swags');
      document.body.append(bar);
    }
    bar.hidden = items.length === 0;
    bar.replaceChildren();
    if (!items.length) return;

    const actions = el('div', 'mrs-compare-bar__actions');
    const go = el('button', 'mrs-compare-bar__go', 'Compare');
    go.type = 'button';
    go.disabled = items.length < 2;
    go.addEventListener('click', openTable);
    const clear = el('button', 'mrs-compare-bar__clear', 'Clear');
    clear.type = 'button';
    clear.addEventListener('click', () => {
      items = [];
      update();
    });
    actions.append(go, clear);

    const slots = el('div', 'mrs-compare-bar__slots');
    for (let i = 0; i < MAX_ITEMS; i += 1) {
      const item = items[i];
      if (!item) {
        const empty = el('div', 'mrs-compare-slot mrs-compare-slot--empty');
        const label = items.length < 2 && i === items.length ? 'Add another swag to compare' : 'Add a swag';
        empty.append(el('span', '', label));
        slots.append(empty);
        continue;
      }
      const slot = el('div', 'mrs-compare-slot');
      if (item.image) {
        const img = el('img');
        img.src = item.image;
        img.alt = '';
        img.loading = 'lazy';
        slot.append(img);
      }
      const text = el('div', 'mrs-compare-slot__text');
      text.append(el('span', 'mrs-compare-slot__title', item.title), el('span', 'mrs-compare-slot__price', item.price));
      const remove = el('button', 'mrs-compare-slot__remove', 'Remove');
      remove.type = 'button';
      remove.setAttribute('aria-label', `Remove ${item.title} from compare`);
      remove.addEventListener('click', () => {
        items = items.filter((entry) => entry.handle !== item.handle);
        update();
      });
      text.append(remove);
      slot.append(text);
      slots.append(slot);
    }
    bar.append(actions, slots);
  }

  function openTable() {
    if (items.length < 2) return;
    if (!dialog) {
      dialog = el('dialog', 'mrs-compare-dialog');
      dialog.setAttribute('aria-label', 'Compare swags');
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      document.body.append(dialog);
    }
    dialog.replaceChildren();

    const head = el('div', 'mrs-compare-dialog__head');
    head.append(el('h2', '', 'Compare swags'));
    const close = el('button', 'mrs-compare-dialog__close', '×');
    close.type = 'button';
    close.setAttribute('aria-label', 'Close');
    close.addEventListener('click', () => dialog.close());
    head.append(close);

    const table = el('table', 'mrs-compare-table');
    const thead = el('thead');
    const headRow = el('tr');
    headRow.append(el('td'));
    items.forEach((item) => {
      const cell = el('td');
      const product = el('div', 'mrs-compare-table__product');
      if (item.image) {
        const img = el('img');
        img.src = item.image;
        img.alt = item.title;
        product.append(img);
      }
      product.append(el('span', 'mrs-compare-table__title', item.title));
      const priceRow = el('div', 'mrs-compare-table__row-price');
      priceRow.append(el('span', 'mrs-compare-table__price', item.price));
      const shop = el('a', 'mrs-compare-table__shop', 'Shop now');
      shop.href = item.url;
      priceRow.append(shop);
      product.append(priceRow);
      cell.append(product);
      headRow.append(cell);
    });
    thead.append(headRow);

    const tbody = el('tbody');
    ROWS.forEach(([key, label]) => {
      const row = el('tr');
      const th = el('th', '', label);
      th.scope = 'row';
      row.append(th);
      items.forEach((item) => {
        const value = item.specs && item.specs[key];
        const cell = el('td');
        if (value) {
          cell.textContent = value;
        } else {
          const ask = el('a', 'mrs-compare-table__ask', 'Ask Us');
          ask.href = '/pages/contact#contact-enquiry';
          cell.append(ask);
        }
        row.append(cell);
      });
      tbody.append(row);
    });

    table.append(thead, tbody);
    const scroll = el('div', 'mrs-compare-dialog__scroll');
    scroll.append(table);
    dialog.append(head, scroll);
    dialog.showModal();
  }

  function update() {
    save();
    syncCheckboxes();
    renderBar();
  }

  document.addEventListener('change', (event) => {
    const input = event.target.closest && event.target.closest('.mrs-compare-toggle__input');
    if (!input) return;
    const data = readCard(input);
    if (!data) return;
    if (input.checked) {
      if (items.some((item) => item.handle === data.handle)) return;
      if (items.length >= MAX_ITEMS) {
        input.checked = false;
        notice(`You can compare up to ${MAX_ITEMS} swags. Remove one first.`);
        return;
      }
      items.push(data);
    } else {
      items = items.filter((item) => item.handle !== data.handle);
    }
    update();
  });

  // Stop a tick on the card from following the card's link.
  document.addEventListener('click', (event) => {
    if (event.target.closest && event.target.closest('.mrs-compare-toggle')) event.stopPropagation();
  }, true);

  // Cards added later (filters, infinite scroll) pick up the saved ticks.
  new MutationObserver(() => syncCheckboxes()).observe(document.body, { childList: true, subtree: true });

  // Refresh saved items with the latest details from cards on this page (price or spec changes).
  document.querySelectorAll('.mrs-compare-toggle__input').forEach((input) => {
    const data = readCard(input);
    if (!data) return;
    items = items.map((item) => (item.handle === data.handle ? data : item));
  });

  update();
})();
